export default __webpack_public_path__ + "static/safe-93ace9a305c28f3092c81e00257c0a0f.png";